import { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { Button } from './ui/button';
import { LogOut, User, MessageSquare, CreditCard, Flame } from 'lucide-react';
import { useCampfireMode } from '../hooks/useCampfireMode';

const Header = () => {
  const { isAuthenticated, user, logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const campfire = useCampfireMode();

  const handleLogout = async () => {
    await logoutUser();
    navigate('/auth');
  };

  return (
    <header className="glass-header sticky top-0 z-50" data-testid="app-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="header-logo-link">
            <img src="https://static.prod-images.emergentagent.com/jobs/92c3925b-8cac-4158-bf1e-ccccfa8395a1/images/2af084f6eec573e35bff8e30dfb19926e74306569c0447689e813bda302278aa.png" alt="I May Help You" className="h-10 w-10" />
            <span className="hidden sm:inline text-xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit' }}>I May Help You</span>
            {campfire && (
              <span
                className="hidden md:inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full border border-[#FF8C3C]/40 bg-[#FF8C3C]/10 text-[#FFB585]"
                title="It's late. You're by the fire. Take your time."
                data-testid="campfire-indicator"
              >
                <Flame className="w-3.5 h-3.5" />
                by the fire
              </span>
            )}
          </Link>
          {isAuthenticated ? (
            <nav className="flex items-center gap-1 sm:gap-4">
              <Link to="/conversations" data-testid="nav-conversations">
                <Button variant="ghost" size="sm" className="text-[#A1A1AA] hover:text-[#F9FAFB] px-2 sm:px-3"><MessageSquare className="w-4 h-4 sm:mr-2" /><span className="hidden sm:inline">History</span></Button>
              </Link>
              <Link to="/support" data-testid="nav-support">
                <Button variant="ghost" size="sm" className="text-[#A1A1AA] hover:text-[#F9FAFB] px-2 sm:px-3"><CreditCard className="w-4 h-4 sm:mr-2" /><span className="hidden sm:inline">Support</span></Button>
              </Link>
              <Link to="/profile" data-testid="nav-profile">
                <Button variant="ghost" size="sm" className="text-[#A1A1AA] hover:text-[#F9FAFB] px-2 sm:px-3"><User className="w-4 h-4 sm:mr-2" /><span className="hidden sm:inline">Profile</span></Button>
              </Link>
              <Button onClick={handleLogout} variant="ghost" size="sm" className="text-[#EF4444] hover:text-[#F87171] px-2 sm:px-3" data-testid="logout-button">
                <LogOut className="w-4 h-4 sm:mr-2" /><span className="hidden sm:inline">Logout</span>
              </Button>
              {user?.is_premium && (
                <span className="px-3 py-1 rounded-full text-xs font-bold bg-[#D4AF37] text-[#0A0A0A]">PREMIUM</span>
              )}
            </nav>
          ) : null}
        </div>
      </div>
    </header>
  );
};

export default Header;
